<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4">To Bill and Sally Smythe,</p>
<p class="p3"> </p>
<p class="p4">Who took us to the edge of the Out Of and</p>
<p class="p4">made it fun despite the sweat,</p>
<p class="p4">the lack of sleep, and the tsetse flies,</p>
<p class="p3"> </p>
<p class="p4">This book is dedicated with friendship and affection.</p>
<p class="p5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?db6062be